import { TrainRounded } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import {
  CircularProgress,
} from '@material-ui/core';
import { ColumnTitle, TableComponent, TableContainer, TableData } from "./styles";
import { ButtonGroup, ButtonHeader, ColumnLeft, ColumnRight, Content, ContentInfo, Header, Table, Td, TdTitle, Th, Title, Tr, TrList, NoData } from "./styles";
import { VIEW_UNIT_BY_DATA } from "./dashboard"
import { useLazyQuery, useQuery } from "@apollo/react-hooks";



const MostAccessedLesson = () => {

  const [activeData, setActiveData] = useState(1);

  const [viewsUnits, {data: dataViewsUnits, loading: loadingViewsUnits, refetch}] = useLazyQuery(VIEW_UNIT_BY_DATA, {
    onCompleted: (e) => {
      console.log(e)
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(()=> {
    viewsUnits({
      variables: {
        days: activeData
      }
    })
  }, [])

  useEffect(()=>{
    console.log(activeData)
    viewsUnits({
      variables: {
        days: activeData
      }
    })
  }, [activeData])

  const LessonsName = [
    "Episídio 1 - China Pro Games - Nome de Grande Bem Grande",
    "Episídio 1 - Multiletramentos",
    "Episódio 1 - Robótica em Ação",
    "Episódio 4 - Introdução a Robótica",
    "Episódio 1 - Sementes da Educação"
  ]

  const LessonsNumber = [
    "500 acessos",
    "156 acessos",
    "148 acessos",
    "145 acessos",
    "126 acessos",
  ]


    return (
      <Content>
      <Header>
        <Title>Aulas mais acessadas</Title>


        <ButtonGroup>
          {activeData === 1?
          <ButtonHeader
            style={{border: "1px solid #DCDDDF",
            borderRadius: "24px"}}
            onClick={(e)=> setActiveData(7)}>
          Dia
          </ButtonHeader>
          :
          <ButtonHeader  onClick={(e)=> setActiveData(1)}>
            Dia
          </ButtonHeader>}

          {activeData === 7?
          <ButtonHeader
            style={{border: "1px solid #DCDDDF",
            borderRadius: "24px"}}
            onClick={(e)=> setActiveData(7)}>
          Semana
          </ButtonHeader>
          :
          <ButtonHeader onClick={(e)=> setActiveData(7)}>
              Semana
          </ButtonHeader>}

          {activeData === 365?
          <ButtonHeader
            style={{border: "1px solid #DCDDDF",
            borderRadius: "24px"}}
            onClick={(e)=> setActiveData(365)}>
          Ano
          </ButtonHeader>
          :
          <ButtonHeader onClick={(e)=> setActiveData(365)}>
              Ano
          </ButtonHeader>}
        </ButtonGroup>
      </Header>
      <ContentInfo>
        {activeData === 1 ?
        <TableContainer>
        <TableComponent>
            <thead>
                <ColumnTitle>

                    <th></th>
                    <th></th>

                </ColumnTitle>
            </thead>

            <tbody>

        <TableData>
        {!loadingViewsUnits ? 
          !dataViewsUnits?.getUnitViewsByData?.length > 0 ? (
            <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <NoData>Não houve nenhum acesso</NoData>
            </div>
          ) : (
            <>
              <td> <ol>
              {dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li>{item.name + ' - ' + item.module.course.name}</li>
              ))}
            </ol></td>
              <td>{dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li style={{listStyleType:"none"}}
                >{item.UnitVideoPlayHistorics.length + ' acessos'}</li>
              ))}</td>
             </>
        ) 
        :
        (
          <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <CircularProgress size={24} color="inherit" />
            </div>
        )}

      </TableData>

            </tbody>
        </TableComponent>
       </TableContainer>
        :null}


{activeData === 7 ?
        <TableContainer>
        <TableComponent>
            <thead>
                <ColumnTitle>

                    <th></th>
                    <th></th>

                </ColumnTitle>
            </thead>

            <tbody>

        <TableData>
        {!loadingViewsUnits ? 
          !dataViewsUnits?.getUnitViewsByData?.length > 0 ? (
            <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <NoData>Não houve nenhum acesso</NoData>
            </div>
          ) : (
            <>
              <td> <ol>
              {dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li>{item.name + ' - ' + item.module.course.name}</li>
              ))}
            </ol></td>
              <td>{dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li style={{listStyleType:"none"}}
                >{item.UnitVideoPlayHistorics.length + ' acessos'}</li>
              ))}</td>
             </>
        ) 
        :
        (
          <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <CircularProgress size={24} color="inherit" />
            </div>
        )}


      </TableData>

            </tbody>
        </TableComponent>
       </TableContainer>
        :null}


{activeData === 365 ?
        <TableContainer>
        <TableComponent>
            <thead>
                <ColumnTitle>

                    <th></th>
                    <th></th>

                </ColumnTitle>
            </thead>

            <tbody>

        <TableData>
        {!loadingViewsUnits ? 
          !dataViewsUnits?.getUnitViewsByData?.length > 0 ? (
            <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <NoData>Não houve nenhum acesso</NoData>
            </div>
          ) : (
            <>
              <td> <ol>
              {dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li>{item.name + ' - ' + item.module.course.name}</li>
              ))}
            </ol></td>
              <td>{dataViewsUnits?.getUnitViewsByData?.map((item)=>(
                <li style={{listStyleType:"none"}}
                >{item.UnitVideoPlayHistorics.length + ' acessos'}</li>
              ))}</td>
             </>
        ) 
        :
        (
          <div style={{justifyContent: 'center', width: '100%', display: 'flex'}}>
              <CircularProgress size={24} color="inherit" />
            </div>
        )}


      </TableData>

            </tbody>
        </TableComponent>
       </TableContainer>
        :null}


      </ContentInfo>
      </Content>
      )}
export default MostAccessedLesson;
